import { createContext } from 'react';
import { StopwatchManager } from '../classes/timeTracking/StopwatchManager/StopwatchManager';
export const stopwatchManagerContextDefaultValue: StopwatchManagerContextValue = {
  get stopwatchManager(): StopwatchManager {
    throw new Error('StopwatchManagerContext not initialized, make sure you are inside the StopwatchManagerContext');
  }
};
export const StopwatchManagerContext = createContext<StopwatchManagerContextValue>(stopwatchManagerContextDefaultValue);
export type StopwatchManagerContextValue = {
  stopwatchManager: StopwatchManager;
};